var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4727 5.52925C12.7331 5.7896 12.7331 6.21171 12.4727 6.47206L8.47271 10.4721C8.21236 10.7324 7.79025 10.7324 7.5299 10.4721L3.5299 6.47206C3.26955 6.21171 3.26955 5.7896 3.5299 5.52925C3.79025 5.2689 4.21236 5.2689 4.47271 5.52925L8.0013 9.05784L11.5299 5.52925C11.7902 5.2689 12.2124 5.2689 12.4727 5.52925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.dfa8269f238d4d0ec818cf3bda15be35.svg";
export { ForwardRef as ReactComponent };